import { render, staticRenderFns } from "./bids_list.vue?vue&type=template&id=530c2b22&scoped=true"
import script from "./bids_list.vue?vue&type=script&lang=js"
export * from "./bids_list.vue?vue&type=script&lang=js"
import style0 from "./bids_list.vue?vue&type=style&index=0&id=530c2b22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530c2b22",
  null
  
)

export default component.exports